import { providersService } from '../services';

export const Model = async () => {
  const { data } = await providersService.getModel();
  return data;
};
